//LOGIN
export const POST_API_JWT_LOGIN = '/auth/signin';
export const POST_API_JWT_LOGOUT = '/auth/signout';
export const POST_RESET_PASSWORD = '/auth/reset-password';
export const POST_CHANGE_THEMEDATA = '/auth/change-themedata';
export const POST_VALIDATE_TOKEN = '/auth/validate-token';
// USER
export const GET_TRAXAA_INTERNAL_USER = '/auth/internal-users';

// NOTIFICATION
export const GET_ALL_UNREAD_NOTIFICATIONS_DATA = '/notifications/unread';
export const MARK_AS_READ_NOTIFICATION = '/notifications/mark-as-read';
export const GET_ALL_NOTIFICATIONS_DATA = '/notifications/notifications';
export const MARK_ALL_AS_READ_NOTIFICATION = '/notifications/mark-all-as-read';

// HEADER SEARCH
export const GET_HEADER_SEARCH_DATA = '/bookings/search';

// DASHBOARD
export const GET_ARRIVAL_AND_DEPARTURE_DATA = '/dashboard/arrival-and-departure-vessel-count';
export const GET_TODAYS_LOADING_BOOKINGS_DATA = '/dashboard/loading-bookings';
export const GET_TOTAL_SHIPMENT_COUNT_BASED_ON_YEAR = '/dashboard/total-bookings';
export const GET_TOTAL_SHIPMENT_COUNT_BASED_ON_CURRENT_MONTH = '/dashboard/total-bookings-of-current-month';
export const GET_NO_OF_BOOKING_OR_CONTAINER_CHARTS_DATA = '/dashboard/booking-counts-of-each-month';
export const GET_BOOKING_CHART_DATA_BASED_ON_SUPPLIER_LOCATION = '/dashboard/booking-basedon-supplier';
export const GET_CONTAINER_COUNTS_BASED_ON_BOOKING_STATUS = '/dashboard/booking-counts-based-on-status';
export const GET_ADVANCED_BOOKING_COUNT_DATA = '/dashboard/advanced-bookings';
export const GET_ADVANCED_BOOKING_DETAILS = '/dashboard/advanced-bookings-details';
export const GET_CHART_DATA_BASED_ON_CUSTOMER = '/dashboard/containers-basedon-customer';
export const GET_CHART_DATA_BASED_ON_COUNTRY = '/dashboard/containers-basedon-country';
export const GET_CHART_DATA_BASED_ON_SHIPPING_LINE = '/dashboard/container-basedon-shippingline';

// BOOKINGS
export const CREATE_OCEAN_SHIPMENT_BOOKING = '/bookings/create-ocean-booking';
export const GET_ALL_CREATE_BOOKING_PRESET_VALUES = '/bookings/booking-prefilled-details';
export const GET_ALL_BOOKINGS_DATA_BASED_ON_SELECTED_MONTH = '/bookings/bookings-based-on-month';
export const GET_ARRIVAL_AND_DEPARTURE_DATA_VALUES = '/dashboard/arrival-and-departure-vessel-details';
export const GET_BOOKING_DETAIL_DATA = '/bookings/booking-details';
export const BOOKING_FILTER_DATA_VALUES = '/bookings/getfilters';
export const GET_BOOKING_COMMENTS_DATA = '/bookings/comments';
export const SAVE_BOOKING_COMMENT_DATA = '/bookings/add-comments';

export const GET_ALL_BOOKING_PARTY_LIST = '/bookings/get-booking-parties';
export const GET_ALL_PARTY_LIST_BASED_ON_PARTY_TYPE = '/bookings/party-search';
export const SAVE_BOOKING_PARTY_DATA = '/bookings/add-booking-party';
export const DELETE_BOOKING_PARTY_DATA = '/bookings/delete-booking-party';

export const GET_BOOKING_DOCUMENT_DATA = '/bookings/get-booking-documents';
export const DOWNLOAD_BOOKING_CONFIRMATION_DOCUMENT = '/bookings/download-booking-confirmation';
export const DOWNLOAD_BOOKING_DOCUMENT = '/bookings/download-booking-documents';
export const SAVE_BOOKING_DOCUMENTS = '/bookings/upload-booking-documents';
export const DELETE_BOOKING_DOCUMENT = '/bookings/delete-booking-document';

export const GET_BOOKING_EMAIL_CONFIRMATION_DATA = '/bookings/show-booking-confirmation';
export const SEND_BOOKING_EMAIL_CONFIRMATION = '/bookings/send-booking-confirmation';

export const GET_BOOKING_TASK_LIST = '/bookings/get-booking-task-list';
export const UPDATE_BOOKING_TASK = '/bookings/edit-booking-task';
export const ADD_BOOKING_TASK = '/bookings/add-booking-task';
export const DELETE_BOOKING_TASK = '/bookings/delete-booking-task';

export const UPDATE_CUTOFF_DETAILS = '/bookings/edit-booking-cutoffs';
export const UPDATE_PURCHASE_PRICE = '/bookings/edit-purchase-price';
export const UPDATE_SALES_PRICE = '/bookings/edit-sales-price';
export const UPDATE_BOOKING_STATUS = '/bookings/edit-booking-status';
export const UPDATE_BOOKING_CUSTOMER = '/bookings/edit-booking-customer';
export const UPDATE_BOOKING_SHIPPING_LINE = '/bookings/edit-booking-shippingline';
export const UPDATE_BOOKING_DATA = '/bookings/edit-booking-details';
export const UPDATE_LOCATION_DATA = '/bookings/edit-booking-location';
export const UPDATE_ASSIGN_BOOKING_USER = '/bookings/assign-booking-users';

export const SPLIT_BOOKING_DATA = '/bookings/split-ocean-booking';

export const GET_BOOKING_EXPORT_COLUMNS = '/bookings/export-columns';

export const GET_CUSTOM_TO_LINE_EMAIL_DATA = '/booking-email/show-custom-to-line-email';
export const SEND_BOOKING_CUSTOM_DOCUMENT = '/booking-email/send-custom-to-line-email';
export const PREVIEW_BOOKING_DOCUMENT_DATA = '/bookings/preview-booking-documents';

export const GET_ALL_BOOKING_OUTLOOK_EMAILS_BY_COMPANY = '/booking-outlook-emails/get-all-emails';

// INVOICES
export const GET_ALL_INVOICE_FILTER_VALUES = '/invoices/filtervalue';
export const SAVE_INVOICE_DATA = '/invoices/saveInvoice';
export const EDIT_INVOICE_DATA = '/invoices/editInvoice';
export const GET_ALL_INVOICES = '/invoices/getInvoices';
export const DELETE_INVOICE = '/invoices/deleteInvoice';
export const DOWNLOAD_INVOICE = '/invoices/downloadInvoice';

export const GET_ALL_INVOICE_LIST_FOR_INVOICE_SCREEN = '/invoices/getAllInvoiceList';
export const GET_ALL_DUE_INVOICES = '/invoices/getAllDueInvoices';
export const GET_INVOICE_CHARGES_LIST = '/invoices/getAllInvoiceCharges';
export const ADD_INVOICE_CHARGES = '/invoices/addNewCharge';
export const DELETE_INVOICE_CHARGES = '/invoices/deleteCharge';
export const GET_CHARGE_INVOICES_LIST = '/invoices/getChargesInvoiceList';

// CUSTOMERS
export const GET_ALL_CUSTOMER_LIST = '/customers/customers-list';
export const UPDATE_CUSTOMER_DETAILS = '/customers/customer-update';
export const SAVE_CUSTOMER_DETAILS = '/customers/customer-add';
export const DELETE_CUSTOMER_DETAILS = '/customers/customer-delete';

export const GET_ALL_CUSTOMER_MEMBERS_LIST = '/customers/members-list';
export const SAVE_CUSTOMER_MEMBER_DATA = '/customers/member-add';
export const UPDATE_CUSTOMER_MEMBER_DATA = '/customers/member-update';
export const DELETE_CUSTOMER_MEMBER_DATA = '/customers/member-delete';

export const GET_ALL_CUSTOMER_SUPPLIER_LIST = '/customers/suppliers-list';
export const GET_ALL_CUSTOMER_NOTIFY_PARTY_LIST = '/customers/notify-parties-list';

export const GET_ALL_CUSTOMER_BOOKING_LIST = '/customers/bookings-list';

// SHIPPING LINE
export const GET_ALL_SHIPPING_LINE_LIST = '/shippinglines/shippingLines-list';
export const ADD_SHIPPING_LINE = '/shippinglines/add-shippingLines';
export const UPDATE_SHIPPING_LINE = '/shippinglines/update-shippingLines';
export const DELETE_SHIPPING_LINE = '/shippinglines/delete-shippingLines';
export const GET_SHIPPING_LINE_DETAILS_BY_ID = '/shippinglines/shippingLines-details';
export const GET_SHIPPING_LINE_BOOKINGS_BY_ID = '/shippinglines/shippingLines-bookings';
export const GET_SHIPPING_LINE_EMAILS_LIST = '/shippinglines/shippingLines-emails-list';
export const ADD_SHIPPING_LINE_EMAILS_DATA = '/shippinglines/shippingLines-emails';
export const UPDATE_SHIPPING_LINE_EMAILS_DATA = '/shippinglines/shippingLines-emails-update';
export const DELETE_SHIPPING_LINE_EMAILS_DATA = '/shippinglines/shippingLines-emails-delete';

// PARTNER
export const GET_ALL_PARTNERS_DATA = '/partners/partners-list';
export const SAVE_PARTNER = '/partners/add-partner';
export const DELETE_PARTNER = '/partners/delete-partner';
export const EDIT_PARTNER = '/partners/edit-partner';
export const GET_PARTNER_DETAILS = '/partners/partner-details';
export const GET_PARTNER_MEMBERS_LIST = '/partners/members-list';
export const ADD_PARTNER_MEMBER = '/partners/add-member';
export const UPDATE_PARTNER_MEMBER = '/partners/update-member';
export const DELETE_PARTNER_MEMBER = '/partners/delete-member';
export const GET_PARTNER_BOOKINGS = '/partners/bookings-list';

// SUPPLIER LOCATIONS
export const GET_SUPPLIER_LOCATIONS_LIST = '/suppliers/all';
export const GET_SUPPLIER_LOCATION_LIST_BY_COUNTRY = '/suppliers/supplier-basedon-country';
export const SAVE_SUPPLIER_LOCATIONS_DATA = '/suppliers/supplier-add';
export const UPDATE_SUPPLIER_LOCATIONS_DATA = '/suppliers/supplier-update';
export const DELETE_SUPPLIER_LOCATIONS_DATA = '/suppliers/supplier-delete';
export const GET_SUPPLIER_LOCATION_DETAILS = '/suppliers/supplier-details';
export const GET_SUPPLIER_LOCATION_BOOKINGS = '/suppliers/bookings-list';

// NOTIFY PARTY
export const GET_NOTIFY_PARTIES_LIST = '/notifyparties/all';
export const SAVE_NOTIFY_PARTIES_DATA = '/notifyparties/party-add';
export const UPDATE_NOTIFY_PARTIES_DATA = '/notifyparties/party-update';
export const DELETE_NOTIFY_PARTIES_DATA = '/notifyparties/party-delete';
export const GET_BOOKINGS_BY_PARTY_ID = '/notifyparties/party-bookings';

// OCEAN PORTS
export const GET_OCEAN_PORT_LIST_BY_COUNTRY = '/oceanports/oceanports-by-country';
export const GET_OCEAN_COUNTRIES = '/common/getCountries';

// TRAXAA CLIENT
export const GET_ALL_TRAXAA_CLIENTS = '/traxaaclient/client-list';
export const SAVE_TRAXAA_CLIENT_INFORMATION = '/traxaaclient/client-add';
export const EDIT_TRAXAA_CLIENT_INFORMATION = '/traxaaclient/client-edit';
export const DOWNLOAD_CLIENT_LOGO = '/traxaaclient/download-client-logo';
export const GET_CLIENT_DETAILS = '/traxaaclient/client-details';
export const ADD_CLIENT_MEMBER = '/traxaaclient/add-member';
export const UPDATE_CLIENT_MEMBER = '/traxaaclient/update-member';
export const DELETE_CLIENT_MEMBER = '/traxaaclient/delete-member';
export const GET_MEMBERS_LIST = '/traxaaclient/members-list';
export const DELETE_TRAXAA_CLIENT = '/traxaaclient/client-delete';

//Templates
export const ADD_EMAIL_TEMPLATE = '/traxaaclient/add-email-template';
export const UPDATE_EMAIL_TEMPLATE = '/traxaaclient/update-email-template';
export const GET_EMAIL_TEMPLATE_LIST = '/traxaaclient/email-templates';
export const DELETE_EMAIL_TEMPLATE = '/traxaaclient/delete-email-template';

//workflows
export const ADD_WORKFLOW_TASK_DATA = '/workflow/add-task';
export const UPDATE_WORKFLOW_TASK_DATA = '/workflow/update-task';
export const GET_WORKFLOW_LIST_DATA = '/workflow/workflows';
export const DELETE_WORKFLOW_TASK = '/workflow/delete-task';
export const COPY_WORKFLOW_TASK = '/workflow/copy-task';
export const DELETE_WORKFLOW = '/workflow/delete-workflow';
export const GET_WORKFLOW_PREFILLED_DATA = '/workflow/prefilled-data';

// CARRIER API
export const GET_SHIPMENT_DETAILS_BY_CARRIER_ID = '/syncWithCarrier/fetch-booking-details';

//Containers
export const GET_CONTAINERS_LIST = '/bookings/get-booking-container-list';
export const SAVE_CONTAINER_DATA = '/bookings/add-booking-container';
export const UPDATE_CONTAINER_DATA = '/bookings/update-booking-container';
export const DELETE_CONTAINER_DATA = '/bookings/delete-booking-container';

//Mrn&Vgm
export const GET_MRN_LIST = '/bookingmrn/all';
export const GET_MRN_BOOKINGS_LIST = '/bookingmrn/bookings';
export const DELETE_BOOKING_MRN = '/bookingmrn/delete-booking-mrn';
export const ADD_BOOKING_TO_MRN = '/bookingmrn/add-to-mrn';
export const UPDATE_MRN_BOOKING_DATA = '/bookingmrn/update-container-details';
export const SUBMIT_BOOKING_VGM_DATA_TO_LINE = '/bookingmrn/send-vgm-to-line';
export const MARK_AS_COMPLETE_MRN_BOOKING = '/bookingmrn/mark-as-completed';
export const SYNC_MRN_BOOKING_DATA = '/bookingmrn/verify-maersk-container-weight';
export const SEND_MRN_BOOKING_MAIL = '/bookingmrn/send-mrn-email';

//Deadline Tracker
export const GET_DT_BOOKING_LIST = '/bookings/get-deadlines-data';
export const SYNC_DT_BOOKING_DATA = '/bookings/check-booking-deadlines';

//Marketing Companies
export const MARKETING_FILTER_DATA_VALUES = '/emailmarketing/getfilters';
export const MARKETING_COMPANIES_LIST = '/emailmarketing/get-companies';
export const GET_MARKETING_COMPANY_DETAILS = '/emailmarketing/get-company-details';
export const ADD_MARKETING_COMPANY_MEMBER = '/emailmarketing/add-member';
export const UPDATE_MARKETING_COMPANY_MEMBER = '/emailmarketing/edit-member';
export const DELETE_MARKETING_COMPANY_MEMBER = '/emailmarketing/delete-member';
export const ADD_MARKETING_COMPANY_DATA = '/emailmarketing/save-company';
export const UPDATE_MARKETING_COMPANY_DATA = '/emailmarketing/edit-company';
export const DELETE_MARKETING_COMPANY_DATA = '/emailmarketing/delete-company';
export const GET_LOGISTIC_GROUPS_AND_SERVICES_LIST = '/emailmarketing/get-logistics-groups-and-service';

export const GET_HS_CODES_LIST = '/common/getHsCodes';

//Contract Rates
export const GET_CONTRACT_RATE_LIST = '/contractprice/getAllPrices';
export const ADD_CONTRACT_DATA = '/contractprice/add-contract';
export const ADD_CONTRACT_PRICE_DATA = '/contractprice/add-prices';
export const UPDATE_CONTRACT_PRICE_DATA = '/contractprice/update-prices';
export const DELETE_CONTRACT_DATA = '/contractprice/delete-contract';
export const DELETE_CONTRACT_PRICE = '/contractprice/delete-prices';
export const COPY_CONTRACT_RATE = '/contractprice/copy-contract';
